import {
  AfterContentInit,
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  inject,
  OnInit,
  Output,
  Input,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { FormBuilder, FormGroup, FormArray, Validators } from '@angular/forms';
import { Outcome } from '../../../outcome/outcome.service';
import { WizardService } from './wizard.service';
import { decodeBase64ToText, encodeToBase64 } from '../../../utility';
import { Filter } from '../../../admin/outcomes/outcomes-interface';
import { AuthService } from '../../../auth/auth.service';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { MessageService } from 'primeng/api';
import { Stepper } from 'primeng/stepper';
import { HelperService } from '../../services/helper.service';
import { ToastService } from '../../services/toast.service';
import { Subscription } from 'rxjs';
import { ApiService } from '../../../api.service';
import { SidebarService } from '../../services/sidebar.service';
@Component({
  selector: 'app-wizard',
  templateUrl: './wizard.component.html',
  styleUrl: './wizard.component.css',
})
export class WizardComponent implements AfterViewInit {
  helper = inject(HelperService);
  toastService = inject(ToastService);
  isStepCompleted = {
    stepOne: false,
    stepTwo: false,
    stepThree: false,
  };
  activeIndex: number = 0;
  isStartOver: boolean = true;
  isDisabled: boolean = false;
  isMileStoneDisabled: boolean = false;

  createBacklogSomeone: boolean = false;
  // checked: boolean = true;
  backlogsForm: FormGroup;
  quarterlyOutcomeForm: FormGroup;
  milestonesForm: FormGroup;
  yearFilter: any = [];
  groupFilter: Filter[] = [];
  annualOutcomesFilter: Filter[] = [];
  userData: any;
  members: any[] = [];
  currentYear: any = new Date().getFullYear();
  //outcomeDetailData: any;
  annualOutcomeName: string = '';
  mileStoneSummary: any = [];
  detailOutcomeData: any = [];
  quarterlyListing: any;
  startOver = {
    backlog_ids: '',
    quarterly_outcome_ids: '',
    milestone_ids: '',
  };
  quarters = [
    {
      label: 'Cycle 1',
      value: '1',
      disabled: !(this.getCurrentQuater() == 1 || this.getNextQuarter() == 1),
    },
    {
      label: 'Cycle 2',
      value: '2',
      disabled: !(this.getCurrentQuater() == 2 || this.getNextQuarter() == 2),
    },
    {
      label: 'Cycle 3',
      value: '3',
      disabled: !(this.getCurrentQuater() == 3 || this.getNextQuarter() == 3),
    },
    {
      label: 'Cycle 4',
      value: '4',
      disabled: !(this.getCurrentQuater() == 4 || this.getNextQuarter() == 4),
    },
  ];
  selectedQuarter: any = null
  quarter: any = [];
  roleSubscription: Subscription;

  apiService = inject(ApiService);
  sidebarService = inject(SidebarService);

  selectedRole: any;
  quaterSubscription: Subscription;

  ngOnInit(): void {
    this.roleSubscription = this.apiService.role$.subscribe((role) => {
      this.selectedRole = role;
      this.getQuarterListByYear(this.selectedRole, this.currentYear);
      this.fetchCurrentQuarter();
    });

    this.quaterSubscription = this.apiService.quarter$
      .subscribe((currentQuater) => {
        if(currentQuater){
          this.selectedQuarter=currentQuater
        }
        
      });
  }

  fetchCurrentQuarter() {
    this.helper.fetchCurrentQuater().subscribe((res: any) => {
      this.apiService.setQuarter(res?.data?.quarter);
    });
  }

  onQuarterChange(event: any, index: number) {
    const fieldsArray = this.getFields(index); 
  
    if (this.isQuarterDisabled(event.value)) {
      fieldsArray.at(index).get('quarter')?.setValue(null); 
    }
  }
  
  isQuarterDisabled(quarter: any): boolean {
    return Number(quarter) < Number(this.selectedQuarter);
  }
  
  

  getQuarterListByYear(cat: any, year: any) {
    this.helper
      .fetchquarterListBasedOnYear(cat, year)
      .subscribe((data: any) => {
        try {
          const parsedData = data;
          this.quarter = parsedData.data || [];
          this.quarterFields(this.quarter);
        } catch (error) {
          console.error('Error parsing decoded data:', error);
        }
      });
  }

  quarterFields(timelines: any[]) {
    timelines.forEach((timeline) => {
      timeline.quarterVal = `Cycle ${timeline.quarter}`;
    });
  }

  typeOfWork = [
    { label: 'Ad-hoc', value: 'Ad-hoc' },
    { label: 'Foundational Work', value: 'Foundational Work' },
    { label: 'Chapter Work Package', value: 'Chapter Work Package' },
    { label: 'Work Package', value: 'Work Package' },
    { label: 'Untagged', value: 'Untagged' },
  ];

  payload = {
    member_id: '',
    outcome_search: '',
  };

  backlogsListing: any = [];
  private messageService = inject(MessageService);
  private wizardService = inject(WizardService);
  public ref = inject(DynamicDialogRef);
  public config = inject(DynamicDialogConfig);
  @ViewChild('customStepper') customStepper!: Stepper;
  outcome_id: any;

  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private cdRef: ChangeDetectorRef
  ) {
    // Initialize the form group with a form array

    this.userData = JSON.parse(
      decodeBase64ToText(this.authService.getCookie())
    );
    this.getYearList();

    this.getGroupList(this.userData.data.user_id);
    this.backlogsForm = this.fb.group({
      group: ['', Validators.required], // FormControl for Group
      year: [this.currentYear.toString(), Validators.required], // FormControl for Year
      annualOutcome: ['', Validators.required], // FormControl for Annual Outcome
      backlogs: this.fb.array([this.createBacklogs()]), // FormArray for Backlog Titles
    });

    this.quarterlyOutcomeForm = this.fb.group({
      quarterly_outcomes: this.fb.array([]),
    });

    this.milestonesForm = this.fb.group({
      milestones: this.fb.array([]),
    });
  }

  ngAfterViewInit(): void {
    if (!this.config?.data) return;
    this.outcome_id =
      this.config?.data?.selectedSTOId || this.config.data?.annualOutcomeId;
    this.customStepper.activeStep = this.config.data.step;
    this.isStartOver = false;
    // this.isDisabled = false;

    if(this.config?.data?.selectedSTOId){
      this.isMileStoneDisabled=true

    }

    switch (this.config?.data?.step) {
      case 0:
        this.handleStepZero();
        break;
      case 1:
        this.isDisabled = true;
        this.handleStepOne();
        break;
      case 2:
        this.handleStepTwo();
        break;
    }
  }

  private handleStepZero(): void {
    const userExists = this.config.data.outcomeData.members.some(
      (m: any) => m.user_id === this.userData.data.user_id
    );

    const backlogsArray = this.backlogsForm.get('backlogs') as FormArray;
    backlogsArray.controls.forEach((backlog) => {
      backlog.get('title')?.setValue(this.config.data.outcomeData?.value);
    });
    this.groupFilter = [this.config.data.outcomeData.groups].map(
      (item: any) => ({
        label: item.name,
        value: item.group_id,
      })
    );

    this.cdRef.detectChanges();
  }

  private handleStepOne(): void {
    // this.getQuarterListByYear(
    //   this.selectedRole,
    //   this.config.data?.year || this.sidebarService.outcomeData.outcome_year
    // );
    this.backlogsListing = [this.config.data.backlogData];
    this.setOutcomesForm(this.backlogsListing);

    this.quarterlyOutcomeForm = this.fb.group({
      quarterly_outcomes: this.fb.array(
        this.backlogsListing.map((data: any) =>
          this.createQuarterlySection(data)
        )
      ),
    });
  }

  private handleStepTwo(): void {
    this.detailOutcomeData = this.config.data.detailOutcomeData;

    this.quarterlyListing = this.config.data.selectedSTOId
      ? this.detailOutcomeData.quarterly.filter(
          (v: any) => v?.outcome_id == this.config.data.selectedSTOId
        )
      : this.detailOutcomeData?.quarterly;
      this.detailOutcomeData.quarterly=this.quarterlyListing
    this.setMileStoneForm(this.quarterlyListing);

    this.milestonesForm = this.fb.group({
      milestones: this.fb.array(
        this.quarterlyListing.map((data: any) =>
          this.createMilestoneSection(data)
        )
      ),
    });
    this.cdRef.detectChanges();
  }

  cacklogSomeone(e: any) {
    // this.createBacklogSomeone = !this.createBacklogSomeone;
    // this.addNameFieldConditionally();
  }

  addNameFieldConditionally(e: any) {
    this.getGroupList(
      this.createBacklogSomeone ? '' : this.userData.data.user_id
    );
    const nameControl = this.backlogsForm.get('name');
    if (this.createBacklogSomeone && !nameControl) {
      this.backlogsForm.addControl(
        'name',
        this.fb.control('', Validators.required)
      ); // Add the 'name' field if condition is true
    } else if (!this.createBacklogSomeone && nameControl) {
      this.backlogsForm.removeControl('name'); // Remove the 'name' field if condition is false
    }
    this.annualOutcomesFilter = [];
    this.backlogsForm.reset();
  }

  getGroupList(userId: number, search: string = ''): void {
    const data = {
      search: search,
      member_id: userId,
    };

    this.wizardService.groupList(data).subscribe(
      (data: any) => {
        try {
          const parsedData = data;
          const group = parsedData.data || [];
          this.groupFilter = group.map((item: any) => ({
            label: item.name,
            value: item.group_id,
          }));
          if (this.config?.data?.step === 0) {
            const userExists = this.config?.data?.outcomeData.members.some(
              (m: any) => m.user_id === this.userData.data.user_id
            );
            this.createBacklogSomeone = !userExists;
            this.groupFilter = [this.config?.data?.outcomeData.groups].map(
              (item: any) => ({
                label: item.name,
                value: item.group_id,
              })
            );
            if (search?.length < 1) {
              this.backlogsForm.patchValue({
                group: this.config?.data?.outcomeData.group_id, // Patch the 'group' field with the desired value
              });
            }

            this.payload = {
              ...this.payload,
              ...{ group_id: this.config?.data?.outcomeData.group_id },
            };
            this.getAnnualOutcomesList(this.payload);
          }
        } catch (error) {
          console.log('Error parsing decoded data:');
        }
      },
      (error) => {
        console.log('Error fetching users');
      }
    );
  }

  getYearList(): void {
    this.wizardService.yeasList({}).subscribe(
      (data: any) => {
        try {
          const parsedData = data;
          this.yearFilter = parsedData.data.reverse() || [];

        } catch (error) {
          console.log('Error parsing decoded data');
        }
      },
      (error) => {
        console.log('Error fetching users');
      }
    );
  }

  onGroupChange(e: any): void {
    this.payload = {
      ...this.payload,
      ...{
        group_id: e.value,
        member_id: this.createBacklogSomeone ? '' : this.userData.data.user_id,
      },
    };
    // this.payload.group_members = e.value
    this.getGroupMembers(e.value);
    if (!this.createBacklogSomeone) {
      this.getAnnualOutcomesList(this.payload);
    }
  }

  getGroupMembers(val: any) {
    const data = {
      groups: val, // Optional
      search: '', // optional
    };
    this.wizardService.groupMembers(data).subscribe(
      (data: any) => {
        try {
          const parsedData = data;
          this.members = parsedData.data || [];
        } catch (error) {
          console.log('Error parsing decoded data');
        }
      },
      (error) => {
        console.log('Error fetching users');
      }
    );
  }

  onAnnualOutcomeChange(e: any): void {
    this.annualOutcomeName = e.originalEvent.target.innerText;
    const backlogsArray = this.backlogsForm.get('backlogs') as FormArray; // Get the FormArray for backlogs

    // Loop through each FormGroup in the FormArray
    backlogsArray.controls.forEach((backlog) => {
      backlog.get('title')?.setValue(this.annualOutcomeName);
    });
  }

  onYearChange(e: any): void {
    this.payload = { ...this.payload, ...{ outcome_year: e.value } };
    if (!this.createBacklogSomeone) {
      this.getAnnualOutcomesList(this.payload);
    }
    this.getQuarterListByYear(this.selectedRole, e.value);
  }

  onSelectMember(e: any): void {
    this.payload = { ...this.payload, ...{ member_id: e.value } };
    this.getAnnualOutcomesList(this.payload);
  }

  getAnnualOutcomesList(data: any, search: string = ''): void {
    data = { ...data, ...{ outcome_search: search } };
    if (this.config.data?.outcomeData?.outcome_type == 'individual') {
      data = { ...data, member_id: this.config.data.outcomeData.accountable };
    }
    this.wizardService.annualOutcomesDropdown(data).subscribe(
      (data: any) => {
        try {
          const parsedData = data;
          this.annualOutcomesFilter = parsedData.data || [];
          if (this.config?.data?.step === 0) {
            if (search?.length < 1) {
              this.backlogsForm.patchValue({
                annualOutcome: this.config?.data?.outcomeData.outcome_id, // Patch the 'group' field with the desired value
              });
            }
          }
        } catch (error) {
          console.log('Error parsing decoded data',error);
        }
      },
      (error) => {
        console.log('Error fetching users');
      }
    );
  }

  createBacklogs(): FormGroup {
    return this.fb.group({
      title: ['', Validators.required],
      accountable_id: [this.userData.data.user_id],
    });
  }

  // Method to create a new set of form fields
  createOutcome(backlog_id: number, title: string = ''): FormGroup {
    return this.fb.group({
      backlog_id: [backlog_id, Validators.required],
      title: [title, Validators.required],
      quarter: ['', Validators.required],
      type: ['', Validators.required],
    });
  }

  createMilestones(outcomeId: number, title: string = ''): FormGroup {
    return this.fb.group({
      outcome_id: [outcomeId, Validators.required],
      title: [title, Validators.required],
      start_date: [''],
      plan_end_date: [''],
      actual_end_date: [''],
    });
  }

  // Getter to access the outcomes form array
  get backlogs() {
    return this.backlogsForm.get('backlogs') as FormArray;
  }

  get quarterlyOutcomes() {
    return this.quarterlyOutcomeForm.get('quarterly_outcomes') as FormArray;
  }

  getFields(sectionIndex: number): FormArray {
    return this.quarterlyOutcomes.at(sectionIndex).get('fields') as FormArray;
  }

  removeFields(sectionIndex: number, fieldIndex: number): void {
    const fields = this.getFields(sectionIndex);
    if (fields.length > 1) {
      fields.removeAt(fieldIndex);
    }
  }

  get milestones() {
    return this.milestonesForm.get('milestones') as FormArray;
  }

  getMilestonesFields(sectionIndex: number): FormArray {
    return this.milestones.at(sectionIndex).get('fields') as FormArray;
  }

  removeMilestoneFields(sectionIndex: number, fieldIndex: number): void {
    const fields = this.getMilestonesFields(sectionIndex);
    if (fields.length > 1) {
      fields.removeAt(fieldIndex);
    }
  }

  // Add a new set of fields

  addMoreBacklogs() {
    this.backlogs.push(this.createBacklogs());
    const backlogsArray = this.backlogsForm.get('backlogs') as FormArray; // Get the FormArray for backlogs

    backlogsArray.controls.forEach((backlog) => {
      const titleControl = backlog.get('title');
      if (titleControl && !titleControl.value) {
        // Set the value only if it's empty or undefined
        titleControl.setValue(this.annualOutcomeName);
      } // Set the title of each backlog
    });
  }

  addMoreOutcomes(sectionIndex: number) {
    const fields = this.getFields(sectionIndex);
    const previousFieldData =
      fields.length > 0 ? fields.at(fields.length - 1).value : null;

    let newFieldData;
    if (previousFieldData) {
      newFieldData = {
        ...previousFieldData,
        start_date: '',
        plan_end_date: '',
        actual_end_date: '',
      };
    }
    fields.push(this.createField(newFieldData));
  }

  addMoreMilestones(sectionIndex: number) {
    const fields = this.getMilestonesFields(sectionIndex);
    const previousFieldData =
      fields.length > 0 ? fields.at(fields.length - 1).value : null;

    let newFieldData;
    if (previousFieldData) {
      newFieldData = {
        ...previousFieldData,
        quarter: '',
        type: '',
      };
    }
    fields.push(this.createMilestonesField(newFieldData));

    // this.milestones.push(this.createMilestones());
  }

  // onMemberChange(e: any) {
  //   const backlogsArray = this.backlogsForm.get('backlogs') as FormArray;

  //   // Loop through all the FormGroups in the FormArray

  //   if(this.createBacklogSomeone)   {
  //     backlogsArray.controls.forEach(group => {
  //       group.patchValue({
  //         accountable_id: e.value
  //       });
  //     });
  //   } else {
  //     backlogsArray.controls.forEach(group => {
  //       group.patchValue({
  //         accountable_id: this.userData.data.user_id
  //       });
  //     });
  //   }
  // }

  onDoneBacklogsSubmit(nextCallback: any, checked: boolean) {
    this.backlogsForm.markAllAsTouched();

    if (this.backlogsForm.valid) {
      const backlogsArray = this.backlogsForm.get('backlogs') as FormArray;
      if (this.createBacklogSomeone) {
        backlogsArray.controls.forEach((group) => {
          group.patchValue({
            accountable_id: this.backlogsForm.get('name')?.value,
          });
        });
      } else {
        backlogsArray.controls.forEach((group) => {
          group.patchValue({
            accountable_id: this.userData.data.user_id,
          });
        });
      }

      const data = {
        ...{
          outcome_id:
            this.backlogsForm.get('annualOutcome')?.value || this.outcome_id,
        },
        ...{ backlogs: this.backlogsForm.value?.backlogs },
      };
      this.wizardService.createBacklogs(data).subscribe(
        (data: any) => {
          try {
            this.isStepCompleted.stepOne = true;
            this.createBacklogSomeone && this.onClose();
            const parsedData = data;
            parsedData?.error
              ? this.toastService.error(parsedData?.message)
              : this.toastService.success(parsedData?.message);
            this.backlogsListing = parsedData.data || [];
              this.helper.isOutcomeDataLoad$.next(true)

            //this.backlogsListing.length && this.setOutcomesForm(this.backlogsListing);
            if (this.backlogsListing.length) {
              this.startOver = {
                ...this.startOver,
                ...{
                  backlog_ids: this.backlogsListing
                    .map((item: any) => item.backlog_id)
                    .join(',')
                    .toString(),
                },
              };
              this.setOutcomesForm(this.backlogsListing);
              this.quarterlyOutcomeForm = this.fb.group({
                quarterly_outcomes: this.fb.array(
                  this.backlogsListing.map((data: any) =>
                    this.createQuarterlySection(data)
                  )
                ),
              });
            }
            if (checked && !parsedData?.error) {
              this.onClose();
            } else {
              this.backlogsListing.length && nextCallback.emit();
            }
          } catch (error) {
            console.log('Error parsing decoded data');
          }
        },
        (error) => {
          console.log('Error fetching users');
        }
      );
    }
  }

  createQuarterlySection(data: any): FormGroup {
    return this.fb.group({
      fields: this.fb.array([this.createField(data)]),
    });
  }

  createField(data: any): FormGroup {
    const { value, title, outcome_id, backlog_id } = data;

    return this.fb.group({
      backlog_id: [backlog_id, Validators.required],
      outcome_id: [outcome_id, Validators.required],
      title: [value || title, Validators.required],
      quarter: ['', Validators.required],
      type: ['', Validators.required],
    });
  }

  createMilestoneSection(data: any): FormGroup {
    return this.fb.group({
      fields: this.fb.array([this.createMilestonesField(data)]),
    });
  }
  createMilestonesField(data: any): FormGroup {
    const { value, title, outcome_id } = data;

    return this.fb.group({
      outcome_id: [outcome_id, Validators.required],
      title: [value || title, Validators.required],
      start_date: [''],
      plan_end_date: [''],
      actual_end_date: [''],
    });
  }

  // Submit the form (for example purposes)
  onBacklogsSubmit(nextCallback: any, checked = false) {
    this.onDoneBacklogsSubmit(nextCallback, checked);
  }

  onQuarterlyOutcomesSubmit(nextCallback: any, isDone: boolean = false) {
    this.quarterlyOutcomeForm.markAllAsTouched();
    const data = {
      quarterly_outcomes:
        this.quarterlyOutcomeForm.value.quarterly_outcomes.flatMap(
          (outcome: any) => {
            return outcome.fields.map((field: any) => {
              // Remove a specific key from each field
              const { outcome_id, ...rest } = field; // Destructure and remove 'fieldToRemove'
              return rest; // Return the remaining fields
            });
          }
        ), // Flatten the 'fields' arrays
    };
    if (this.quarterlyOutcomeForm.valid) {
      //const data = this.quarterlyOutcomeForm.value;
      this.wizardService.createOutcomesData(data).subscribe(
        (data: any) => {
          try {
            this.isStepCompleted.stepTwo = true;
            const parsedData = data;

            this.quarterlyListing = parsedData.data || [];
            if (this.quarterlyListing.length) {
              this.startOver = {
                ...this.startOver,
                ...{
                  quarterly_outcome_ids: this.quarterlyListing
                    .map((item: any) => item.outcome_id)
                    .join(',')
                    .toString(),
                },
              };
              this.setMileStoneForm(this.quarterlyListing);
              // this.quarterlyOutcomeForm = this.fb.group({
              //   quarterly_outcomes: this.fb.array(this.backlogsListing.map((data: any) => this.createQuarterlySection(data)))
              // });

              this.milestonesForm = this.fb.group({
                milestones: this.fb.array(
                  this.quarterlyListing.map((data: any) =>
                    this.createMilestoneSection(data)
                  )
                ),
              });
              this.mileStoneSummary = this.mergeBackLogAndOutcomeData(
                this.backlogsListing,
                parsedData.data
              );
            }
            this.helper.isOutcomeDataLoad$.next(true)
            this.messageService.add({
              severity: 'success',
              summary: 'Success',
              detail: parsedData.message,
            });
            isDone ? this.onClose() : nextCallback.emit();
          } catch (error) {
            console.log('Error parsing decoded data', error);
          }
        },
        (error) => {
          console.log('Error fetching users');
        }
      );
    }
  }

  onMilestonesSubmit() {
    const outcomeId =
      this.milestonesForm.value.milestones
        .flatMap((section: any) => section.fields)
        ?.find((field: any) => field.outcome_id)?.outcome_id || null;
    this.milestonesForm.markAllAsTouched();
    if (this.milestonesForm.valid) {
      const data = {
        outcome_id: outcomeId || this.outcome_id,
        milestones: this.milestonesForm.value.milestones.flatMap(
          (section: any) => section.fields
        ), // Flatten the 'fields' arrays
      };
      this.wizardService.createMilestonesData(data).subscribe(
        (data: any) => {
          try {
            this.isStepCompleted.stepThree = true;
            const parsedData = data;
            parsedData?.error
              ? this.toastService.error(
                  parsedData?.message || 'Interval Server Error'
                )
              : this.toastService.success(parsedData?.message);
            this.onClose();
          } catch (error) {
            console.log('Error parsing decoded data');
          }
        },
        (error) => {
          console.log('Error fetching users');
        }
      );
    }
  }

  outcomeDetail(val: number) {
    const data = {
      outcome_id: val.toString(),
      accountable_id: this.userData.data.user_id,
    };
    this.wizardService.backlogListByOutcome(data).subscribe(
      (data: any) => {
        try {
          const parsedData = data;
          this.backlogsListing = parsedData.data || [];
          this.setOutcomesForm(this.backlogsListing);
        } catch (error) {
          console.log('Error parsing decoded data');
        }
      },
      (error) => {
        console.log('Error fetching users');
      }
    );
  }

  setOutcomesForm(data: any) {
    const outcomesArray = this.quarterlyOutcomeForm.get(
      'quarterly_outcomes'
    ) as FormArray;
    outcomesArray.clear();
    // Loop through the aa array and create FormGroups
    data.forEach((item: any) => {
      // console
      const outcome = this.createOutcome(item.backlog_id, item.value);
      outcomesArray.push(outcome);
    });
  }

  setMileStoneForm(data: any) {
    const milestoneArray = this.milestonesForm.get('milestones') as FormArray;
    milestoneArray.clear();
    // Loop through the aa array and create FormGroups
    data.forEach((item: any) => {
      // console
      const milestone = this.createMilestones(item.outcome_id, item.value);
      milestoneArray.push(milestone);
    });
  }

  getTitleValue(index: number): string {
    const milestoneGroup = (
      this.quarterlyOutcomeForm.get('quarterly_outcomes') as FormArray
    ).at(index);
    return milestoneGroup.get('title')?.value;
  }

  showHintValue(text: string) {
    let textCount = text.split(' ');
    let textString = text;
    if (textCount.length > 5) {
      textString = text.split(' ').slice(0, 5).join(' ') + '...';
    } else {
      textString = text;
    }
    return textString;
  }

  onClose() {
    this.createBacklogSomeone = false;
    this.ref.close();
  }

  mergeBackLogAndOutcomeData(backlog: any, quarterly: any) {
    return backlog.map((item: any) => {
      // Filter items from 'b' that match the 'backlog_id' from the current 'item' in 'aa'
      const quarterlyOutcomes = quarterly?.filter(
        (quarter: any) => quarter.backlog_id === item.backlog_id
      );

      // Return the new structure with the 'quartlyOutcome' property
      return {
        ...item,
        quartlyOutcome: quarterlyOutcomes,
      };
    });
  }
  @Output() prevCallback = new EventEmitter<void>();

  onBackClick(prevCallback: any, formData: any, type?: string) {
    let paylaod = {
      backlog_ids: '', // optional comma saperated ids
      quarterly_outcome_ids: '', // optional comma saperated ids
      milestone_ids: '', // optional comma saperated ids
    };
    if (type == 'milestone') {
      paylaod.quarterly_outcome_ids = formData?.value?.milestones
        .flatMap((outcome: any) =>
          outcome.fields.map((field: any) => field?.outcome_id)
        )
        .join(',');
    } else {
      const backlogIds = formData?.value?.quarterly_outcomes
        .flatMap((outcome: any) =>
          outcome.fields.map((field: any) => field?.backlog_id)
        )
        .join(',');
      paylaod.backlog_ids = backlogIds;
    }

    this.prevCallback.emit();
    this.wizardService.startOver(paylaod).subscribe(
      (response: any) => {
        prevCallback.emit();
      },
      (error: any) => {
        console.error('API Error:', error);
        this.prevCallback.emit();
        prevCallback.emit();
      }
    );
  }

  onStartOver(index: any) {
    this.wizardService.startOver(this.startOver).subscribe(
      (data: any) => {
        try {
          const parsedData = data;

          this.backlogsForm.reset();
          this.quarterlyOutcomeForm.reset();
          this.milestonesForm.reset();
          this.customStepper.activeStep = 0;
          this.annualOutcomeName = '';
        } catch (error) {
          console.log('Error parsing decoded data');
        }
      },
      (error) => {
        console.log('Error fetching users');
      }
    );
  }

  getCurrentQuater() {
    let date: any = new Date();
    return Math.floor((date.getMonth() + 3) / 3);
  }

  getNextQuarter() {
    const currentDate = new Date();
    const currentMonth = currentDate.getMonth(); // 0-based index (0 = January, 11 = December)
    const currentQuarter = Math.floor(currentMonth / 3) + 1;

    return currentQuarter === 4 ? 1 : currentQuarter + 1;
  }

  onGroupSearch(e: any) {
    // if (e.filter.length >= 3) {
    this.getGroupList(
      this.createBacklogSomeone ? '' : this.userData.data.user_id,
      e.filter
    );
    // }
  }

  onAnnualOutcomeSearch(e: any) {
    // if (e.filter.length >= 3) {
    // this.getGroupList(this.createBacklogSomeone ? '' : this.userData.data.user_id, e.filter)
    this.getAnnualOutcomesList(this.payload, e.filter);
    // }
  }


  ngOnDestroy() {
    if (this.ref) {
      this.ref.close();
    }
    if (this.roleSubscription) {
      this.roleSubscription.unsubscribe();
    }

    if (this.quaterSubscription) {
      this.quaterSubscription.unsubscribe();
    }
  }
}
